import { Component, HostListener, Inject, OnInit, Renderer2 } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import * as feather from 'feather-icons';
import { roleService } from '../../services/rolebase-services';
import { MenuItem, MessageService } from 'primeng/api';
import { ThemeService } from '../../services/theme.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TabService } from '../../tab.service';
import { DOCUMENT } from '@angular/common';
import { ChangeColorModalComponent } from '../change-color-modal/change-color-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { icons, svgs } from 'src/app/icons';
import { SharedService } from '../../shared.service';
import { AccessControlService } from '../../services/AccessControl.service';
import { ReferComponent } from '../refer/refer.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  providers: [MessageService,DialogService]
})
export class SidebarComponent implements OnInit{
  ref: DynamicDialogRef | undefined;
  isMobile: boolean = false;
  isModuleActive:boolean=false;
  isSubModuleActive:boolean= false;
  items: MenuItem[] = [];
  themeValue = false;
  theme = 'dark'
  sidebarType = 'left'
  showHideSettingsModule = false
  svgIcon: any;
  svgIcons = icons
  roleIds: any;
  roleNames:any;
  menu:any;
  menuItems: any;
  
  showLoader = true
  showLogoutPopup = false;
  constructor(private auth: AuthService, public roleService: roleService,public themeService: ThemeService,public router: Router,
    @Inject(DOCUMENT) private document: Document,private route: ActivatedRoute,public sanitizer: DomSanitizer, private sharedService: SharedService,
    private renderer: Renderer2,public dialogService: DialogService,private tabService: TabService,private accessControlService: AccessControlService) {
    this.sidebarType = localStorage.getItem('sidebarType')!
    document.body.classList.remove('top-sidebar')
    this.checkIfMobile();
  }
  
  ngAfterViewInit() {
    feather.replace();
  }

  ngOnInit() {
    const isExpanded = localStorage.getItem('expandedSidebar')
    if(isExpanded === 'true'){
      this.renderer.removeClass(this.document.body, 'sidebar-collapse');
    }
    else{
      this.renderer.addClass(this.document.body, 'mini-sidebar')
    }

    const theme = localStorage.getItem('darkTheme')
    this.themeValue = theme === 'true' ? true : false
    const userData = JSON.parse(localStorage.getItem('UserDetails') || '{}');
    // this.roleIds = userData?.roleId ? userData?.roleId : userData?.id;
    this.roleIds = userData?.userRoles?.map((role: any) => role.roleId) || [];
    this.roleNames = userData?.userRoles?.map((role: any) => role.name) || [];

    this.sharedService.updateLoader(true);
    this.getModuleSubmodule()
    const bgType = localStorage.getItem('bgType');
    const primaryColor = localStorage.getItem('backgroundPrimaryColor')
    document.documentElement.style.setProperty('--background-primary-color', primaryColor);
    document.documentElement.style.setProperty('--background-primary-hover-color', (primaryColor + '14'));
    const mainBgColor = localStorage.getItem('backgroundMainColor')
    if(bgType === 'gradiant'){
      document.body.style.backgroundColor = ''
      document.body.style.setProperty('--main-background-color', mainBgColor);
    }
    else{
      document.body.style.setProperty('--main-background-color', mainBgColor);
      if(this.themeValue){
        document.body.style.backgroundColor = ''
      }
      else{
        document.body.style.backgroundColor = mainBgColor!
      }
    }
    const sidebarBgColor = localStorage.getItem('backgroundSidebarColor')
    document.documentElement.style.setProperty('--sidebar-background-color', sidebarBgColor);
    const mainTextColor = localStorage.getItem('mainTextColor')
    document.documentElement.style.setProperty('--main-text-color', mainTextColor);
    this.items = [
      {
        label: 'Manage Product',
        icon: 'pi pi-fw pi-user',
        routerLink:"/product-services/product-list"
      },
      {
        label: 'Manage Product Attributes',
        icon: 'pi pi-fw pi-user',
        routerLink:"/product-services/product-attribute"
      },
      {
        label: 'Upload Products',
        icon: 'pi pi-fw pi-user',
        routerLink:"/product-services/upload-product"
      },
    ];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkIfMobile(); // Check whenever the window is resized
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth < 769; 
  }

  toggleNavMobile() {
    if (this.isMobile) {
      const toggleBtn: any = document.getElementById('mobile_btn');

      const body = document.body;
      // const wrapper = document.querySelector(".main-wrapper");

      if (document.querySelector(".slide-nav")) {
        document.querySelector(".main-wrapper")?.classList.remove("slide-nav");

        body.classList.remove('menu-opened');
        // toggleBtn.classList.add('active');
        // localStorage.setItem(screenModeNightTokenState, 'night');
        setTimeout(() => {
          body.classList.remove('mini-sidebar');
          document.querySelector(".header-left")?.classList.add("active");
        }, 100);
      } else {
        document.querySelector(".main-wrapper")?.classList.add("slide-nav");

        body.classList.add('menu-opened');
        toggleBtn.classList.remove('active');
        // localStorage.removeItem(screenModeNightTokenState);
        setTimeout(() => {
          body.classList.add('mini-sidebar');
          document.querySelector(".header-left")?.classList.remove("active");
        }, 100);
      }
    }
  }
  logOut() {
    this.auth.logOut()
  }
  toggleTheme() {
    this.themeService.toggleTheme();
  }

  changeTheme(){
    this.ref = this.dialogService.open(ChangeColorModalComponent, {
      // header: 'Select a Product',
      width: '35vw',
      data: {
        type: 'user'
      },
      contentStyle: { overflow: 'auto' },
      draggable: true
      // breakpoints: {
      //   '960px': '75vw',
      //   '640px': '90vw',
      // },
      // templates: {
      //   footer: Footer,
      // },
    });
  
    this.ref.onClose.subscribe((data: any) => {
      let summary_and_detail;
      if (data) {
        setTimeout(() => {
          this.showLogoutPopup = true
        }, 100);
      } else {
        
      }
      // this.messageService.add({
      //   severity: 'info',
      //   ...summary_and_detail,
      //   life: 3000,
      // });
    });
  }

  addNewTab(item:any) {
    this.tabService.addTab({
      label: item.subModuleName, path: item.subModuleEndpoint,
      fullPath: '',
      filterData: []
    });
  }
  addNewTabmaster(item:any) {
    this.tabService.addTab({
      label: item.moduleName, path: item.moduleEndpoint,
      fullPath: '',
      filterData: []
    });
  }
  showSettingsModule(){
    this.showHideSettingsModule = !this.showHideSettingsModule
  }
  getModuleSubmodule() {
    this.auth.getAggregatedSideMenuPermissions(this.roleIds).subscribe(
      (res: any) => {
        // Filter modules with readAccess === 1 and their submodules
        // this.menu = res.responseObject
        //   .filter((module: any) => module.status === 1)
        //   .map((module: any) => ({
        //     ...module,
        //     // subModules: module?.subModules.filter((sub: any) => sub?.readAccess === 1)
        //   }));
          // const data ={
          //   active: true,
          //   createdAt: "08-09-2025 07:08:45 +0530",
          //   createdBy: 1,
          //   id: 14342,
          //   isDefault: false,
          //   moduleEndpoint: "orders/pickup-request",
          //   moduleIcon: "Order_Management",
          //   moduleId: 1,
          //   moduleName: "Pickup Request",
          //   read: true,
          //   sortSequence: 0,
          //   status: 1,
          //   submodulePermissions: [],
          //   update: true,
          //   updatedAt: "08-09-2025 07:08:48 +0530",
          //   updatedBy: 1,
          //   write: true
          // }
          const data =  [
          //   {
          //     createdAt: "08-09-2025 07:10:53 +0530",
          //     updatedAt: "08-09-2025 07:10:56 +0530",
          //     createdBy: 1,
          //     updatedBy: 1,
          //     id: 21312,
          //     moduleId: 3,
          //     moduleName: "Order",
          //     moduleIcon: "Order_Management",
          //     status: 1,
          //     active: true,
          //     read: true,
          //     write: true,
          //     update: true,
          //     isDefault: false,
          //     sortSequence: 2,
          //     moduleEndpoint: "",
          //     submodulePermissions: [
          //         {
          //             createdAt: "09-09-2025 04:42:48 +0530",
          //             updatedAt: "09-09-2025 04:42:50 +0530",
          //             createdBy: 1,
          //             updatedBy: 1,
          //             id: 213213,
          //             subModuleId: 4,
          //             subModuleName: "Pickup Request",
          //             subModuleEndpoint: "/orders/pickup-request",
          //             read: true,
          //             write: true,
          //             update: true,
          //             isDefault: false
          //         },
          //     ]
          // },
          {
            createdAt: "08-09-2025 07:10:53 +0530",
            updatedAt: "08-09-2025 07:10:56 +0530",
            createdBy: 1,
            updatedBy: 1,
            id: 32141,
            moduleId: 3,
            moduleName: "MIS Mapping",
            moduleIcon: "Mapping",
            status: 1,
            active: true,
            read: true,
            write: true,
            update: true,
            isDefault: false,
            sortSequence: 2,
            moduleEndpoint: "",
            submodulePermissions: [
                {
                    createdAt: "09-09-2025 04:42:48 +0530",
                    updatedAt: "09-09-2025 04:42:50 +0530",
                    createdBy: 1,
                    updatedBy: 1,
                    id: 312331,
                    subModuleId: 87,
                    subModuleName: "Customer MIS Mapping",
                    subModuleEndpoint: "/mis-mapping/customer-mis-mapping",
                    read: true,
                    write: true,
                    update: true,
                    isDefault: false
                },
                {
                  createdAt: "09-09-2025 04:42:48 +0530",
                  updatedAt: "09-09-2025 04:42:50 +0530",
                  createdBy: 1,
                  updatedBy: 1,
                  id: 312389,
                  subModuleId: 41,
                  subModuleName: "Vendor MIS Mapping",
                  subModuleEndpoint: "/mis-mapping/vendor-mis-mapping",
                  read: true,
                  write: true,
                  update: true,
                  isDefault: false
              },
            ]
        },
          {
            createdAt: "08-09-2025 07:10:53 +0530",
            updatedAt: "08-09-2025 07:10:56 +0530",
            createdBy: 1,
            updatedBy: 1,
            id: 32131,
            moduleId: 3,
            moduleName: "Tracking",
            moduleIcon: "Tracking",
            status: 1,
            active: true,
            read: true,
            write: true,
            update: true,
            isDefault: false,
            sortSequence: 2,
            moduleEndpoint: "",
            submodulePermissions: [
                {
                    createdAt: "09-09-2025 04:42:48 +0530",
                    updatedAt: "09-09-2025 04:42:50 +0530",
                    createdBy: 1,
                    updatedBy: 1,
                    id: 312312,
                    subModuleId: 4,
                    subModuleName: "Appointments",
                    subModuleEndpoint: "/tracking/appointments",
                    read: true,
                    write: true,
                    update: true,
                    isDefault: false
                },
                {
                  createdAt: "09-09-2025 04:42:48 +0530",
                  updatedAt: "09-09-2025 04:42:50 +0530",
                  createdBy: 1,
                  updatedBy: 1,
                  id: 312312,
                  subModuleId: 4,
                  subModuleName: "Track Docket",
                  subModuleEndpoint: "/tracking/track-docket",
                  read: true,
                  write: true,
                  update: true,
                  isDefault: false
              },
            ]
        },
        {
          createdAt: "08-09-2025 07:10:53 +0530",
          updatedAt: "08-09-2025 07:10:56 +0530",
          createdBy: 1,
          updatedBy: 1,
          id: 36131,
          moduleId: 3,
          moduleName: "Quality",
          moduleIcon: "Quality",
          status: 1,
          active: true,
          read: true,
          write: true,
          update: true,
          isDefault: false,
          sortSequence: 2,
          moduleEndpoint: "",
          submodulePermissions: [
              {
                  createdAt: "09-09-2025 04:42:48 +0530",
                  updatedAt: "09-09-2025 04:42:50 +0530",
                  createdBy: 1,
                  updatedBy: 1,
                  id: 317312,
                  subModuleId: 4,
                  subModuleName: "POD Audit",
                  subModuleEndpoint: "/quality/pod-audit",
                  read: true,
                  write: true,
                  update: true,
                  isDefault: false
              },
          ]
        },
        {
          createdAt: "08-09-2025 07:10:53 +0530",
          updatedAt: "08-09-2025 07:10:56 +0530",
          createdBy: 1,
          updatedBy: 1,
          id: 36131,
          moduleId: 3,
          moduleName: "Finance",
          moduleIcon: "Finance",
          status: 1,
          active: true,
          read: true,
          write: true,
          update: true,
          isDefault: false,
          sortSequence: 2,
          moduleEndpoint: "",
          submodulePermissions: [
              {
                  createdAt: "09-09-2025 04:42:48 +0530",
                  updatedAt: "09-09-2025 04:42:50 +0530",
                  createdBy: 1,
                  updatedBy: 1,
                  id: 317312,
                  subModuleId: 4,
                  subModuleName: "Customer Billing",
                  subModuleEndpoint: "/finance/customer-billing",
                  read: true,
                  write: true,
                  update: true,
                  isDefault: false
              },
              {
                createdAt: "09-09-2025 04:42:48 +0530",
                updatedAt: "09-09-2025 04:42:50 +0530",
                createdBy: 1,
                updatedBy: 1,
                id: 317392,
                subModuleId: 4,
                subModuleName: "Additional Charges Master",
                subModuleEndpoint: "/finance/addition-charges-master",
                read: true,
                write: true,
                update: true,
                isDefault: false
            },
            {
              createdAt: "09-09-2025 04:42:48 +0530",
              updatedAt: "09-09-2025 04:42:50 +0530",
              createdBy: 1,
              updatedBy: 1,
              id: 3134392,
              subModuleId: 4,
              subModuleName: "Vendor Billing",
              subModuleEndpoint: "/finance/vendor-billing",
              read: true,
              write: true,
              update: true,
              isDefault: false
          },
          {
            createdAt: "09-09-2025 04:42:48 +0530",
            updatedAt: "09-09-2025 04:42:50 +0530",
            createdBy: 1,
            updatedBy: 1,
            id: 316492,
            subModuleId: 4,
            subModuleName: "Credit/Debit Note",
            subModuleEndpoint: "/finance/credit-debit-note",
            read: true,
            write: true,
            update: true,
            isDefault: false
        },
          ]
      }
        ]
          res?.responseObject.push(...data)
           this.menu = res.responseObject
          .filter((module: any) => module.read === true)
          .map((module: any) => ({
            ...module,
            submodulePermissions: module.submodulePermissions.filter((sub: any) => sub.read === true)
          }));
  
        // Process icons for modules and submodules
        this.menu.forEach((el: any) => {
          const moduleIcon = el.moduleIcon;
          if (svgs[moduleIcon]) {
            el.moduleIcon = this.sanitizer.bypassSecurityTrustHtml(svgs[moduleIcon]);
          }
          // console.log( this.menu)
          // el?.subModules.forEach((ele: any) => {
          //   const subModuleIcon = ele.subModuleIcon;
          //   if (svgs[subModuleIcon]) {
          //     ele.moduleIcon = this.sanitizer.bypassSecurityTrustHtml(svgs[subModuleIcon]);
          //   }
          // });
        });
  
        this.showLoader = false;
        this.accessControlService.setAccessControlData(res.responseObject);
        this.sharedService.updateLoader(false);
      },
      (error: any) => {
        this.sharedService.updateLoader(false);
        this.showLoader = false;
      }
    );
  }

 addMenuTab(url:any){
      this.tabService.addTab({
        label: 'Profile', path: url,
        fullPath: '',
        filterData: [],
        // pageNumber: 0,
        // pageSize: 10
      });
    // this.router.navigate([url],{ queryParams: params })
    }

    addRefer(){
      this.ref = this.dialogService.open(ReferComponent, {
            header: `Refer`,
            data: '',
            width: '35vw',
            contentStyle: { overflow: 'auto', position: "top" },
            draggable: true,
            styleClass: 'no-close-icon-dialog',
          });
          this.ref.onClose.subscribe((data: any) => {
            console.log("resss", data)
            if (data) {
            
            }
          });
    }
}
